import { Component, OnInit, Renderer2 } from '@angular/core';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { Createproject } from 'src/app/model/createproject.model';
import { Vendorregistration } from 'src/app/model/vendorregistration.model';
import { UserService } from 'src/app/services/user/user.service';
import { Searchgeneral } from 'src/app/model/searchgeneral.model';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from 'src/app/services/role/role.service';
import { HttpClient } from '@angular/common/http';
import { Roleassign } from 'src/app/model/role/roleassign.model';
import { ViewChild } from '@angular/core';
import { RecaptchaComponent } from 'ng-recaptcha';


@Component({
  selector: 'app-StartSurvey',
  templateUrl: './StartSurvey.component.html',
  styleUrls: ['./StartSurvey.component.css']
})
export class StartSurveyComponent implements OnInit {



  formdata: any;
  isLoading: boolean = false;
  quotaFullBool: boolean = false;
  linkQuotaFull: string;
  projectid: string;
  clid: string;
  tableBool: boolean = false;
  quest: any = [];
  clip: string;
  qestCount: number;
  mobileCheck: boolean = false;
  securityCheck: any;
  quotafullstatus: string;
  re: string;
  captchaBool: Boolean = false;
  invisiblerecaptchaBool: boolean = false;
  isInvisibleCaptchaEnabled: boolean = false;
  Questions: any;
  CustomPageEnable: boolean = false;
  link: string;
  vendorUrl: any;
  linkNew: string;
  questBoolnew: boolean = false;
  networkBool: boolean = false;
  custompagetext: string;
  status: string;
  isThreat: boolean = true;
  researchData: any;
  isQuestionSubmitted: boolean = false;
  constructor(private router: Router, private _http: HttpClient, private route: ActivatedRoute, private toastr: ToastrService, private roleservice: RoleService, private userService: UserService, private _renderer: Renderer2) {
    this.projectid = this.route.snapshot.params.id;
    this.clid = this.route.snapshot.params.clid;
    this.clip = this.route.snapshot.params.clip;
    this.re = this.route.snapshot.params.re;
    this.status = this.route.snapshot.params.s;
  }

  @ViewChild('invisibleRecaptcha', { static: false }) invisibleRecaptcha: RecaptchaComponent;






  ngOnInit() {
    debugger;
    //this.MobileCheck();

    if (!this.isRecaptchaScriptLoaded()) {
      // Dynamically load the reCAPTCHA script
      this.loadRecaptchaScript();
    }

    this.isLoading = true;

    this.userService.getResearchDefenderData(this.projectid).subscribe((researchDatas: any) => {

      this.researchData = researchDatas;
      this.isInvisibleCaptchaEnabled = this.researchData.invisiblerecaptcha;
      //this.invisiblerecaptchaBool = this.isInvisibleCaptchaEnabled;

      if (this.researchData.isResearchEnabled == true || this.researchData.isActivityEnabled == true) {
        if (this.researchData.isResearchEnabled == true && this.researchData.isActivityEnabled == false) {
          this.callResearchDefenderAPI();
        }
        else if (this.researchData.isResearchEnabled == false && this.researchData.isActivityEnabled == true) {
          this.callResearchActivityAPI();
        }
        else if (this.researchData.isResearchEnabled == true && this.researchData.isActivityEnabled == true) {
          this.callSearchAndActivityAPI();
        }
        else {
          this.surveyChecks();
        }
      }
      // if (this.researchData.isResearchEnabled && this.researchData.isResearchEnabled == true) {
      //   var researchUrl = this.researchData.apiUrl + "/" + this.researchData.licenseKey + "?sy_nr=" + this.projectid + "&sn_ud=" + this.clid + "&rt_sr_pd=" + this.re;
      //   this.userService.callResearchDefender(researchUrl).subscribe(
      //     (data: any) => {
      //       console.log("consoling research defender result");
      //       console.log(data);
      //       if (data != null) {
      //         if (data.Respondent) {
      //           if (data.Respondent.threat_potential_score) {
      //             if (data.Respondent.threat_potential_score < this.researchData.threat_Potential_Score_Valid) {
      //               this.surveyChecks();
      //             }
      //             else {
      //               this.link = "There is some problem with network. " + this.researchData.threat_Message;
      //               this.captchaBool = false;
      //               this.isThreat = true;
      //               this.networkBool = true;
      //               this.isLoading = false;
      //               this.researchErrorLog(JSON.stringify(data));
      //             }
      //           }
      //           else {
      //             this.link = "There is some problem with network. " + this.researchData.threat_Message;
      //             this.captchaBool = false;
      //             this.isThreat = true;
      //             this.networkBool = true;
      //             this.isLoading = false;

      //           }
      //         }
      //         else {
      //           this.link = "There is some problem with network. " + this.researchData.threat_Message;
      //           this.captchaBool = false;
      //           this.isThreat = true;
      //           this.networkBool = true;
      //           this.isLoading = false;
      //         }
      //       }
      //       else {
      //         this.link = "There is some problem with network. " + this.researchData.threat_Message;
      //         this.captchaBool = false;
      //         this.isThreat = true;
      //         this.networkBool = true;
      //         this.isLoading = false;
      //       }
      //     },
      //     (error: any) => {
      //       this.link = "There is some problem with network. " + this.researchData.threat_Message;
      //       this.captchaBool = false;
      //       this.isThreat = true;
      //       this.networkBool = true;
      //       this.isLoading = false;
      //     }
      //   )
      // }
      else {
        this.surveyChecks();
      }


    });


  }

  /*
  callResearchDefenderAPI() {
    if (this.researchData.isResearchEnabled && this.researchData.isResearchEnabled == true) {
      var researchUrl = this.researchData.apiUrl + "/" + this.researchData.licenseKey + "?sy_nr=" + this.projectid + "&sn_ud=" + this.clid + "&rt_sr_pd=" + this.re;
      this.userService.callResearchDefender(researchUrl).subscribe(
        (data: any) => {
          console.log("consoling research defender result");
          console.log(data);
          if (data != null) {
            if (data.Respondent) {
              if (data.Respondent.threat_potential_score) {
                if (data.Respondent.threat_potential_score < this.researchData.threat_Potential_Score_Valid) {
                  this.researchErrorLog(JSON.stringify(data), 'search', false);
                  this.surveyChecks();
                }
                else {
                  this.link = "There is some problem with network. " + this.researchData.threat_Message;
                  this.captchaBool = false;
                  this.isThreat = true;
                  this.networkBool = true;
                  this.isLoading = false;
                  this.researchErrorLog(JSON.stringify(data), 'search', true);
                }
              }
              else {
                this.researchErrorLog(("data.Respondent.threat_potential_score failure"), 'search', true);
                this.link = "There is some problem with network. " + this.researchData.threat_Message;
                this.captchaBool = false;
                this.isThreat = true;
                this.networkBool = true;
                this.isLoading = false;
              }
            }
            else {
              this.researchErrorLog(("data.Respondent failure"), 'search', true);
              this.link = "There is some problem with network. " + this.researchData.threat_Message;
              this.captchaBool = false;
              this.isThreat = true;
              this.networkBool = true;
              this.isLoading = false;
            }
          }
          else {
            this.researchErrorLog(("data failure"), 'search', true);
            this.link = "There is some problem with network. " + this.researchData.threat_Message;
            this.captchaBool = false;
            this.isThreat = true;
            this.networkBool = true;
            this.isLoading = false;
          }
        },
        (error: any) => {
          this.researchErrorLog(("unable to call Research defender api" + JSON.stringify(error)), 'search', true);
          this.link = "There is some problem with network. " + this.researchData.threat_Message;
          this.captchaBool = false;
          this.isThreat = true;
          this.networkBool = true;
          this.isLoading = false;
        }
      )
    }
  }
  */

  callResearchDefenderAPI() {
    if (this.researchData.isResearchEnabled && this.researchData.isResearchEnabled == true) {
      var tokenUrl = this.researchData.searchTokenUrl + "/" + this.researchData.searchTokenPublicKey;
      debugger;
      this.userService.callTokenApiSearch(tokenUrl).subscribe(
        (data: any) => {
          debugger;
          if (data != null) {
            if (data.results != null) {
              if (data.results.length > 0 && data.results[0].token != null) {

                var researchUrl = this.researchData.apiUrl + "/" + this.researchData.licenseKey + "?sy_nr=" + this.projectid + "&sn_ud=" + this.clid + "&rt_sr_pd=" + this.re;
                this.userService.callResearchDefender(researchUrl, data.results[0].token).subscribe(
                  (data: any) => {
                    debugger;
                    console.log("consoling research defender result");
                    console.log(data);
                    if (data != null) {
                      if (data.Respondent) {
                        if (data.Respondent.threat_potential_score) {
                          if (data.Respondent.threat_potential_score < this.researchData.threat_Potential_Score_Valid) {
                            this.researchErrorLog(JSON.stringify(data), 'search', false);
                            this.surveyChecks();
                          }
                          else {
                            this.link = "There is some problem with network. " + this.researchData.threat_Message;
                            this.captchaBool = false;
                            this.isThreat = true;
                            this.networkBool = true;
                            this.isLoading = false;
                            this.markSurveyTerminated();
                            this.researchErrorLog(JSON.stringify(data), 'search', true);

                          }
                        }
                        else {
                          this.markSurveyTerminated();
                          this.researchErrorLog(("data.Respondent.threat_potential_score failure"), 'search', true);
                          this.link = "There is some problem with network. " + this.researchData.threat_Message;
                          this.captchaBool = false;
                          this.isThreat = true;
                          this.networkBool = true;
                          this.isLoading = false;
                        }
                      }
                      else {
                        this.markSurveyTerminated();
                        this.researchErrorLog(("data.Respondent failure"), 'search', true);
                        this.link = "There is some problem with network. " + this.researchData.threat_Message;
                        this.captchaBool = false;
                        this.isThreat = true;
                        this.networkBool = true;
                        this.isLoading = false;
                      }
                    }
                    else {
                      this.markSurveyTerminated();
                      this.researchErrorLog(("data failure"), 'search', true);
                      this.link = "There is some problem with network. " + this.researchData.threat_Message;
                      this.captchaBool = false;
                      this.isThreat = true;
                      this.networkBool = true;
                      this.isLoading = false;
                    }
                  },
                  (error: any) => {
                    this.markSurveyTerminated();
                    this.researchErrorLog(("unable to call Research defender api" + JSON.stringify(error)), 'search', true);
                    this.link = "There is some problem with network. " + this.researchData.threat_Message;
                    this.captchaBool = false;
                    this.isThreat = true;
                    this.networkBool = true;
                    this.isLoading = false;
                  }
                )
              }
            }
          }
        }
      )


    }
  }

  callResearchActivityAPI() {
    debugger;
    if (this.researchData.isActivityEnabled && this.researchData.isActivityEnabled == true) {
      //for new activity check
      //var activityUrl = this.researchData.activityUrl + "?sy_nr=" + this.projectid + "&range=" + this.researchData.activity_Hours + "&sn_ud=" + this.clid + "&rt_sr_pd=" + this.re;

      //for old activity check
      var activityUrl = this.researchData.activityUrl + "/" + this.researchData.activityLicenseKey + "?sy_nr=" + this.projectid + "&range=" + this.researchData.activity_Hours + "&sn_ud=" + this.clid + "&rt_sr_pd=" + this.re;


      this.userService.callResearchActivityApi(activityUrl, this.researchData.activityLicenseKey).subscribe(
        (data: any) => {
          console.log("consoling research Activity result");
          console.log(data);
          debugger;
          if (data != null) {
            if (data.statistics && data.statistics.length > 0) {
              if (data.statistics[0].activity) {
                if (data.statistics[0].activity.token1 && data.statistics[0].activity.token2) {
                  if (data.statistics[0].activity.token1.count < this.researchData.activity_Count_Valid &&
                    data.statistics[0].activity.token2.count < this.researchData.activity_Count_Valid) {
                    this.researchErrorLog(JSON.stringify(data), 'activity', false);
                    this.surveyChecks();
                  }
                  else {
                    this.link = "There is some problem with network. " + this.researchData.activity_Message;
                    this.captchaBool = false;
                    this.isThreat = true;
                    this.networkBool = true;
                    this.isLoading = false;
                    this.markSurveyTerminated();
                    this.researchErrorLog(JSON.stringify(data), 'activity', true);
                  }
                }
                else {
                  this.markSurveyTerminated();
                  this.researchErrorLog(("data.statistics[0].activity.token1 && data.statistics[0].activity.token2 failure"), 'activity', true);
                  this.link = "There is some problem with network. " + this.researchData.activity_Message;
                  this.captchaBool = false;
                  this.isThreat = true;
                  this.networkBool = true;
                  this.isLoading = false;

                }
              }
              else {
                this.markSurveyTerminated();
                this.researchErrorLog(("data.statistics[0].activity failure"), 'activity', true);
                this.link = "There is some problem with network. " + this.researchData.activity_Message;
                this.captchaBool = false;
                this.isThreat = true;
                this.networkBool = true;
                this.isLoading = false;
              }
            }
            else {
              this.markSurveyTerminated();
              this.researchErrorLog(("data.statistics[0].activity failure"), 'activity', true);
              this.link = "There is some problem with network. " + this.researchData.activity_Message;
              this.captchaBool = false;
              this.isThreat = true;
              this.networkBool = true;
              this.isLoading = false;
            }
          }
          else {
            this.markSurveyTerminated();
            this.researchErrorLog(("data failure"), 'activity', true);
            this.link = "There is some problem with network. " + this.researchData.activity_Message;
            this.captchaBool = false;
            this.isThreat = true;
            this.networkBool = true;
            this.isLoading = false;
          }
        },
        (error: any) => {
          this.markSurveyTerminated();
          this.researchErrorLog(("unable to call Research defender Activity api" + JSON.stringify(error)), 'activity', true);
          this.link = "There is some problem with network. " + this.researchData.activity_Message;
          this.captchaBool = false;
          this.isThreat = true;
          this.networkBool = true;
          this.isLoading = false;
        }
      )
    }
  }

  callSearchAndActivityAPI() {
    if (this.researchData.isResearchEnabled && this.researchData.isResearchEnabled == true) {

      var tokenUrl = this.researchData.searchTokenUrl + "/" + this.researchData.searchTokenPublicKey;

      this.userService.callTokenApiSearch(tokenUrl).subscribe(
        (data: any) => {
          if (data != null) {
            if (data.results != null) {
              if (data.results.length > 0 && data.results[0].token != null) {
                var researchUrl = this.researchData.apiUrl + "/" + this.researchData.licenseKey + "?sy_nr=" + this.projectid + "&sn_ud=" + this.clid + "&rt_sr_pd=" + this.re;
                this.userService.callResearchDefender(researchUrl, data.results[0].token).subscribe(
                  (data: any) => {
                    debugger;
                    console.log("consoling research defender result");
                    console.log(data);
                    if (data != null) {
                      if (data.Respondent) {
                        if (data.Respondent.threat_potential_score) {
                          if (data.Respondent.threat_potential_score < this.researchData.threat_Potential_Score_Valid) {
                            this.researchErrorLog(JSON.stringify(data), 'search_activity', false);
                            this.callResearchActivityAPI();
                          }
                          else {
                            this.link = "There is some problem with network. " + this.researchData.threat_Message;
                            this.captchaBool = false;
                            this.isThreat = true;
                            this.networkBool = true;
                            this.isLoading = false;
                            this.markSurveyTerminated();
                            this.researchErrorLog(JSON.stringify(data), 'search_activity', true);
                          }
                        }
                        else {
                          this.markSurveyTerminated();
                          this.researchErrorLog(("data.Respondent.threat_potential_score failure"), 'search_activity', true);
                          this.link = "There is some problem with network. " + this.researchData.threat_Message;
                          this.captchaBool = false;
                          this.isThreat = true;
                          this.networkBool = true;
                          this.isLoading = false;

                        }
                      }
                      else {
                        this.markSurveyTerminated();
                        this.researchErrorLog(("data.Respondent failure"), 'search_activity', true);
                        this.link = "There is some problem with network. " + this.researchData.threat_Message;
                        this.captchaBool = false;
                        this.isThreat = true;
                        this.networkBool = true;
                        this.isLoading = false;
                      }
                    }
                    else {
                      this.markSurveyTerminated();
                      this.researchErrorLog(("data failure"), 'search_activity', true);
                      this.link = "There is some problem with network. " + this.researchData.threat_Message;
                      this.captchaBool = false;
                      this.isThreat = true;
                      this.networkBool = true;
                      this.isLoading = false;
                    }
                  },
                  (error: any) => {
                    this.markSurveyTerminated();
                    this.researchErrorLog(("unable to call Research defender search_activity api" + JSON.stringify(error)), 'search_activity', true);
                    this.link = "There is some problem with network. " + this.researchData.threat_Message;
                    this.captchaBool = false;
                    this.isThreat = true;
                    this.networkBool = true;
                    this.isLoading = false;
                  }
                )
              }
            }
          }
        }
      )
    }
  }

  /*
  callSearchAndActivityAPI() {
    if (this.researchData.isResearchEnabled && this.researchData.isResearchEnabled == true) {
      var researchUrl = this.researchData.apiUrl + "/" + this.researchData.licenseKey + "?sy_nr=" + this.projectid + "&sn_ud=" + this.clid + "&rt_sr_pd=" + this.re;
      this.userService.callResearchDefender(researchUrl).subscribe(
        (data: any) => {
          console.log("consoling research defender result");
          console.log(data);
          if (data != null) {
            if (data.Respondent) {
              if (data.Respondent.threat_potential_score) {
                if (data.Respondent.threat_potential_score < this.researchData.threat_Potential_Score_Valid) {
                  this.researchErrorLog(JSON.stringify(data), 'search_activity', false);
                  this.callResearchActivityAPI();
                }
                else {
                  this.link = "There is some problem with network. " + this.researchData.threat_Message;
                  this.captchaBool = false;
                  this.isThreat = true;
                  this.networkBool = true;
                  this.isLoading = false;
                  this.researchErrorLog(JSON.stringify(data), 'search_activity', true);
                }
              }
              else {
                this.researchErrorLog(("data.Respondent.threat_potential_score failure"), 'search_activity', true);
                this.link = "There is some problem with network. " + this.researchData.threat_Message;
                this.captchaBool = false;
                this.isThreat = true;
                this.networkBool = true;
                this.isLoading = false;

              }
            }
            else {
              this.researchErrorLog(("data.Respondent failure"), 'search_activity', true);
              this.link = "There is some problem with network. " + this.researchData.threat_Message;
              this.captchaBool = false;
              this.isThreat = true;
              this.networkBool = true;
              this.isLoading = false;
            }
          }
          else {
            this.researchErrorLog(("data failure"), 'search_activity', true);
            this.link = "There is some problem with network. " + this.researchData.threat_Message;
            this.captchaBool = false;
            this.isThreat = true;
            this.networkBool = true;
            this.isLoading = false;
          }
        },
        (error: any) => {
          this.researchErrorLog(("unable to call Research defender search_activity api" + JSON.stringify(error)), 'search_activity', true);
          this.link = "There is some problem with network. " + this.researchData.threat_Message;
          this.captchaBool = false;
          this.isThreat = true;
          this.networkBool = true;
          this.isLoading = false;
        }
      )
    }
  }
  */

  researchErrorLog(data, errorType, isfailed) {
    var errordata = {
      errorMessage: data,
      projectId: this.projectid,
      clid: this.clid,
      clip: this.clip,
      status: this.re,
      apiType: errorType,
      isFailed: isfailed
    }
    this.userService.researchErrorLog(errordata).subscribe(
      (data: any) => {
      }
    )
  }

  surveyChecks() {
    this.isThreat = false;
    if (this.status == undefined) {
      this.userService.getQuotaFullStatus(this.projectid, this.clid).subscribe(
        (data) => {
          debugger;
          this.quotafullstatus = data.toString();
          if (this.quotafullstatus == "notquotafull") {
            this.quotaFullBool = false;
            var element = <HTMLInputElement>document.getElementById('navbarId');
            if (element != null) {
              element.style.display = 'none';
            }
            let script = this._renderer.createElement('script');
            script.defer = true;
            script.async = true;
            script.src = "https://www.google.com/recaptcha/api.js";
            this._renderer.appendChild(document.body, script);
            this.captchaBool = true;
            this.isLoading = false;

            this.userService.getCatchaQuestionnaireCheck(this.projectid, this.clid).subscribe(
              (data) => {
                debugger;
                this.securityCheck = data;
                if (data[0] != undefined) {
                  //var invrecap = data[0]['invisiblerecaptcha']
                  var invrecap = this.isInvisibleCaptchaEnabled;
                  var capt = data[0]['recaptcha'];
                  var questionn = data[0]['questionnaire'];
                  var mobileBool = data[0]['mobile'];
                  //this.invisiblerecaptchaBool = invrecap;
                }
                else {
                  //var invrecap = data['invisiblerecaptcha']
                  var invrecap = this.isInvisibleCaptchaEnabled;
                  var capt = data['recaptcha'];
                  var questionn = data['questionnaire'];
                  var mobileBool = data['mobile'];
                  //this.invisiblerecaptchaBool = invrecap;

                }
                console.log(this.securityCheck);
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                  // true for mobile device
                  //console.log("mobile device");
                  this.mobileCheck = true;
                } else {
                  // false for not mobile device
                  //console.log("not mobile device");
                  this.mobileCheck = false;
                }

                if ((mobileBool == 1 && this.mobileCheck) || (mobileBool == 0 && !this.mobileCheck) || (mobileBool == 2)) {
                  if (capt && this.status == undefined) {
                    this.captchaBool = true;
                    this.tableBool = false;
                  }
                  else if (!capt && questionn && this.status == undefined) {
                    this.tableBool = true;
                    this.captchaBool = false;
                  }
                  else {
                    this.tableBool = false;
                    this.captchaBool = false;
                    if (this.isInvisibleCaptchaEnabled) {
                      this.invisiblerecaptchaBool = true;

                      //alert("hello2");
                      this.executeInvisibleRecaptcha();
                    }
                    else {
                      this.invisiblerecaptchaBool = false;
                      this.startsurvey();
                    }

                  }

                  if (questionn) {
                    this.userService.getQuestionForProject(this.projectid, this.clid).subscribe(
                      (data) => {
                        debugger;
                        this.Questions = data;
                        this.qestCount = this.Questions.length;
                        if (this.qestCount == 0 && !capt) {
                          this.tableBool = false;
                          this.captchaBool = false;
                          if (this.isInvisibleCaptchaEnabled) {
                            this.invisiblerecaptchaBool = true;
                            //alert("hello1");

                            this.executeInvisibleRecaptcha();
                          }
                          else {
                            this.invisiblerecaptchaBool = false;
                            this.startsurvey();
                          }
                        }
                        else if (this.qestCount == 0 && capt) {
                          this.tableBool = false;
                          this.captchaBool = true;
                        }
                        console.log(data[0]);
                      }
                    )
                  }
                  else {
                    this.qestCount = 0;
                  }
                }
                else {
                  this.captchaBool = false;
                  this.tableBool = false;
                  this.linkQuotaFull = "Message : There is a device access limitation. You cannot access this survey link of current device !"
                  this.quotaFullBool = true;
                  this.networkBool = false;
                  this.isLoading = false;
                }
              }
            )

          }
          else if (this.quotafullstatus == "quotafull") {
            this.captchaBool = false;
            this.tableBool = false;
            //this.quotaFullBool = true;
            this.networkBool = false;
            this.isLoading = false;
            this.userService.InsertQuotaFullRecord(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
              (data) => {
                var dataLength = data.toString().split('||').length;
                if (dataLength == 3) {
                  this.link = data.toString().split('||')[0];
                  var VendLinkUrl = data.toString().split('||')[1];
                  this.networkBool = true;
                  this.isLoading = false;
                  if (VendLinkUrl) {
                    setTimeout(() => {
                      window.open(VendLinkUrl, "_self");
                    }, 3000);
                    // this.getVendorLinks();
                    // console.log(this.vendorUrl);
                  }
                }
                //this.linkQuotaFull = "Message : Quota is Full for this Project !"
              })
          }
        })
    }
    else {
      this.captchaBool = false;
      this.tableBool = false;
      this.quotaFullBool = false;
      this.networkBool = false;
      this.qestCount = 0;
      this.resolved("");
    }
  }

  resolved(token) {
    // this.captchaBool = false;
    // this.isLoading = true;
    //debugger;

    if (this.isInvisibleCaptchaEnabled) {
      this.invisiblerecaptchaBool = true;
      //alert("hello1");

      this.executeInvisibleRecaptcha();
    }
    else {
      this.captchaBool = false;
      this.isLoading = true;
      this.invisiblerecaptchaBool = false;
      this.captchav2Resolved();
    }

  }

  captchav2Resolved() {
    if (this.qestCount == 0) {
      this.tableBool = false;
      if (this.status == undefined) {
        this.userService.surveyUrl(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
          (data) => {
            debugger;
            if (data.toString().split("||").length == 1) {
              this.link = data.toString();
              if (this.link.includes("http://") || this.link.includes("https://")) {
                window.open(this.link, "_self");
                this.isLoading = false;
              }
              else if (this.link.includes("There is some problem with network")) {
                this.networkBool = true;
                this.isLoading = false;
              }
              else if (this.link.includes("You have already participated in this study. Thank you for your time.")) {
                this.networkBool = true;
                //console.log(this.link);
                this.isLoading = false;
              }
              else if (this.link.includes("You are not authorized to run this link in other Country. Thank you for your time.")) {
                this.networkBool = true;
                //console.log(this.link);
                this.isLoading = false;
              }
              else {
                this.CustomPageEnable = true;
                this.custompagetext = this.link //this.decodeEntities( data.toString());
                this.isLoading = false;
                console.log(this.custompagetext);
              }
            }
            else if (data.toString().split("||").length == 2) {
              this.link = data.toString().split("||")[0];
              if (this.link.includes("Your answers have been received and this survey is now completed")) {
                this.networkBool = true;
                this.isLoading = false;
                // this.getVendorLinks();
                // console.log(this.vendorUrl);
              }
              else if (this.link.includes("Thank you for sharing your opinions!")) {
                this.networkBool = true;
                this.isLoading = false;
              }
              else if (this.link.includes("Thanks for your opinion to share.")) {
                this.networkBool = true;
                this.isLoading = false;
              }
              else if (this.link.includes("Thank you for your interest and sharing your opinion.")) {
                this.networkBool = true;
                this.isLoading = false;
              }
            }
            //console.log(data);
          }
        )
      }
      else {
        this.userService.surveyUrl(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
          (data) => {
            debugger;
            var dataLength = data.toString().split('||').length;
            if (dataLength == 1) {
              this.link = data.toString().split('||')[0];
              if (this.link.includes("http://") || this.link.includes("https://")) {
                window.open(this.link, "_self");
                this.isLoading = false;
              }
              else if (this.link.includes("There is some problem with network")) {
                this.networkBool = true;
                this.isLoading = false;
              }
              else if (this.status == "1" || this.status == "2" || this.status == "3" || this.status == "4") {
                this.networkBool = true;
                this.isLoading = false;
                // this.getVendorLinks();
                // console.log(this.vendorUrl);
              }
              else {
                this.CustomPageEnable = true;
                this.custompagetext = data.toString() // this.decodeEntities( data.toString());
                this.isLoading = false;
                console.log(this.custompagetext);
              }
              //console.log(data);
            }
            else if (dataLength == 2) {
              this.link = data.toString().split('||')[0];
              if (this.status == "1" || this.status == "2" || this.status == "3" || this.status == "4") {
                this.networkBool = true;
                this.isLoading = false;
                // this.getVendorLinks();
                // console.log(this.vendorUrl);
              }
              else {
                this.CustomPageEnable = true;
                this.custompagetext = data.toString() // this.decodeEntities( data.toString());
                this.isLoading = false;
                console.log(this.custompagetext);
              }
            }
            else if (dataLength == 3) {
              this.link = data.toString().split('||')[0];
              var VendLinkUrl = data.toString().split('||')[1];
              if (this.status == "1" || this.status == "2" || this.status == "3" || this.status == "4") {
                this.networkBool = true;
                this.isLoading = false;
                if (VendLinkUrl) {
                  setTimeout(() => {
                    window.open(VendLinkUrl, "_self");
                  }, 3000);
                  // this.getVendorLinks();
                  // console.log(this.vendorUrl);
                }
              }
              else {
                this.CustomPageEnable = true;
                this.custompagetext = data.toString() // this.decodeEntities( data.toString());
                this.isLoading = false;
                console.log(this.custompagetext);
              }
            }
          }
        )
      }

    }
    else {
      this.tableBool = true;
      this.isLoading = false;
    }
  }

  OnSubmit(form: NgForm) {
    this.formdata = form;
    // if (this.isInvisibleCaptchaEnabled) {
    //   this.invisiblerecaptchaBool = true;
    //   //alert("hello3");
    //   this.executeInvisibleRecaptcha();
    // } else
    this.submitFormData(this.formdata);
  }

  resolvedd(token: string): void {
    // Handle reCAPTCHA response
    debugger;
    console.log('reCAPTCHA resolved:', token);

    var verifydata = {
      errorMessage: '',
      projectId: this.projectid,
      clid: this.clid,
      clip: this.clip,
      status: this.re,
      apiType: 'Captcha',
      isFailed: false,
      captchaToken: token
    }

    this.userService.verifyCaptcha(verifydata).subscribe(
      (data: any) => {
        debugger;
        console.log(data);
        if (data == true) {
          if (this.captchaBool == true && this.tableBool == false && !this.isQuestionSubmitted) {
            this.captchaBool = false;
            this.isLoading = true;
            this.captchav2Resolved();
          }
          else if (this.isQuestionSubmitted) {
            this.startSurveyForQuestionnaire();
          }
          else {
            this.startsurvey();
          }
        }
        else {
          this.markSurveyTerminated();
          alert("Captcha didn't resolved");
        }
      }
    )

    // Now you can access the stored form data
    //console.log('Form data:', this.formdata);
    // if (this.isQuestionSubmitted) {
    //   this.startSurveyForQuestionnaire();
    // }
    // else {
    //   this.startsurvey();
    // }

    // Call the function to submit the form data
    //this.submitFormData(this.formdata);
  }

  submitFormData(form: NgForm) {


    debugger;
    var ansSelected = "";
    var questAns = this.Questions;
    form.value.clid = this.clid;
    for (var i = 0; i < questAns.length; i++) {
      ansSelected = "";
      var id = questAns[i];
      if (questAns[i].questionType == "1" || questAns[i].questionType == "2" || questAns[i].questionType == "4") {
        var ans = questAns[i].options.split(',')
        for (var z = 0; z < ans.length; z++) {
          var element = <HTMLInputElement>document.getElementById(questAns[i].questionID + z);
          var ansChecked = element.checked;
          if (ansChecked) {
            ansSelected = ansSelected + element.value.trim() + ",";
          }
        }
        if (ansSelected != "")
          ansSelected = ansSelected.slice(0, -1);

        form.value[id.questionID] = ansSelected;
      }
    }
    let arr = [];
    Object.keys(form.value).map(function (key) {
      arr.push({ [key]: form.value[key] })
    });

    // for(var i=0;i<arr.length;i++)
    // {
    //   var test = arr[i]//.split(':')[1];
    //   if(test == undefined)
    //   {
    //     test = "";
    //     arr[i].split(':')[1] = test;
    //   }

    // }
    console.log(form.value);

    this.userService.saveAnswers(form.value).subscribe(
      (data) => {
        debugger;
        // console.log(data);
        if (data) {
          this.isQuestionSubmitted = true;
          if (this.isInvisibleCaptchaEnabled) {
            this.invisiblerecaptchaBool = true;
            //alert("hello3");
            this.executeInvisibleRecaptcha();
          }
          else {
            this.startSurveyForQuestionnaire();
          }
          /*
          this.tableBool = false;
          this.isLoading = true;
          if (this.status == undefined) {
            this.userService.surveyUrl(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
              (data) => {
                debugger;
                if (data.toString().split("||").length == 1) {
                  this.link = data.toString();
                  if (this.link.includes("http://") || this.link.includes("https://")) {
                    console.log(this.link);
                    window.open(this.link, "_self");
                    this.isLoading = false;
                  }
                  else if (this.link.includes("There is some problem with network")) {
                    this.networkBool = true;
                    this.isLoading = false;
                    console.log(this.link);
                  }
                  else if (this.link.includes("You have already participated in this study. Thank you for your time.")) {
                    this.networkBool = true;
                    console.log(this.link);
                    this.isLoading = false;
                  }
                  else if (this.link.includes("You are not authorized to run this link in other Country. Thank you for your time.")) {
                    this.networkBool = true;
                    console.log(this.link);
                    this.isLoading = false;
                  }
                  else {
                    this.CustomPageEnable = true;
                    this.custompagetext = this.link //this.decodeEntities( data.toString());
                    this.isLoading = false;
                    console.log(this.custompagetext);
                  }
                }
                else if (data.toString().split("||").length == 2) {
                  this.link = data.toString().split("||")[0];
                  if (this.link.includes("Your answers have been received and this survey is now completed")) {
                    this.networkBool = true;
                    this.isLoading = false;
                    // this.getVendorLinks();
                    // console.log(this.vendorUrl);
                  }
                  else if (this.link.includes("Thank you for sharing your opinions!")) {
                    this.networkBool = true;
                    this.isLoading = false;
                    console.log(this.link);
                  }
                  else if (this.link.includes("Thanks for your opinion to share.")) {
                    this.networkBool = true;
                    this.isLoading = false;
                    console.log(this.link);
                  }
                  else if (this.link.includes("Thank you for your interest and sharing your opinion.")) {
                    this.networkBool = true;
                    this.isLoading = false;
                    console.log(this.link);
                  }
                }
                //console.log(data);
              }
            )
          }
          else {
            this.userService.surveyUrl(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
              (data) => {
                debugger;
                console.log(this.projectid, this.clid, this.clip, this.re, this.status);
                console.log("First", data);
                this.link = data.toString();
                if (this.link.includes("http://") || this.link.includes("https://")) {
                  console.log(this.link);
                  window.open(this.link, "_self");
                  this.isLoading = false;

                }
                else if (this.link.includes("There is some problem with network")) {
                  console.log(this.link);
                  this.networkBool = true;
                  this.isLoading = false;
                }
                else if (this.status == "1" || this.status == "2" || this.status == "3" || this.status == "4") {
                  this.networkBool = true;
                  //this.link = this.decodeEntities(this.link);
                  this.isLoading = false;
                  // this.getVendorLinks();
                  // console.log(this.vendorUrl);
                }
                else {
                  this.CustomPageEnable = true;
                  this.custompagetext = data.toString(); // this.decodeEntities( data.toString());
                  this.isLoading = false;
                  console.log(this.custompagetext);
                }
                //console.log(data);
              }
            )
          }
          */
        }
        else {
          this.toastr.error("You are not qualified for the survey", '', { progressBar: true });
          this.captchaBool = false;
          this.tableBool = false;
          this.status = "3";

          this.userService.InsertQuotaFullRecord(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
            (data) => {
              var dataLength = data.toString().split('||').length;
              if (dataLength == 3) {
                this.link = data.toString().split('||')[0];
                var VendLinkUrl = data.toString().split('||')[1];
                this.networkBool = true;
                this.isLoading = false;
                if (VendLinkUrl) {
                  setTimeout(() => {
                    window.open(VendLinkUrl, "_self");
                  }, 3000);
                }
              }
            })


          // this.userService.surveyUrl(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
          //   (data) => {
          //     debugger;
          //     console.log(this.projectid, this.clid, this.clip, this.re, this.status);
          //     console.log("First", data);
          //     this.link = data.toString();
          //     if (this.link.includes("http://") || this.link.includes("https://")) {
          //       window.open(this.link, "_self");
          //       this.isLoading = false;

          //     }
          //     else if (this.link.includes("There is some problem with network")) {
          //       this.networkBool = true;
          //       this.isLoading = false;
          //     }
          //     else if (this.status == "1" || this.status == "2" || this.status == "3" || this.status == "4") {
          //       this.networkBool = true;
          //       this.isLoading = false;
          //       // this.getVendorLinks();
          //       // console.log(this.vendorUrl);
          //     }
          //     else {
          //       this.CustomPageEnable = false;
          //       this.custompagetext = data.toString() // this.decodeEntities( data.toString());
          //       this.isLoading = false;
          //     }
          //   }
          // )
        }
      }
    )

  }

  startSurveyForQuestionnaire() {
    debugger;
    this.tableBool = false;
    this.isLoading = true;
    if (this.status == undefined) {
      this.userService.surveyUrl(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
        (data) => {
          debugger;
          if (data.toString().split("||").length == 1) {
            this.link = data.toString();
            if (this.link.includes("http://") || this.link.includes("https://")) {
              console.log(this.link);
              window.open(this.link, "_self");
              this.isLoading = false;
            }
            else if (this.link.includes("There is some problem with network")) {
              this.networkBool = true;
              this.isLoading = false;
              console.log(this.link);
            }
            else if (this.link.includes("You have already participated in this study. Thank you for your time.")) {
              this.networkBool = true;
              console.log(this.link);
              this.isLoading = false;
            }
            else if (this.link.includes("You are not authorized to run this link in other Country. Thank you for your time.")) {
              this.networkBool = true;
              console.log(this.link);
              this.isLoading = false;
            }
            else {
              this.CustomPageEnable = true;
              this.custompagetext = this.link //this.decodeEntities( data.toString());
              this.isLoading = false;
              console.log(this.custompagetext);
            }
          }
          else if (data.toString().split("||").length == 2) {
            this.link = data.toString().split("||")[0];
            if (this.link.includes("Your answers have been received and this survey is now completed")) {
              this.networkBool = true;
              this.isLoading = false;
              // this.getVendorLinks();
              // console.log(this.vendorUrl);
            }
            else if (this.link.includes("Thank you for sharing your opinions!")) {
              this.networkBool = true;
              this.isLoading = false;
              console.log(this.link);
            }
            else if (this.link.includes("Thanks for your opinion to share.")) {
              this.networkBool = true;
              this.isLoading = false;
              console.log(this.link);
            }
            else if (this.link.includes("Thank you for your interest and sharing your opinion.")) {
              this.networkBool = true;
              this.isLoading = false;
              console.log(this.link);
            }
          }
          //console.log(data);
        }
      )
    }
    else {
      this.userService.surveyUrl(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
        (data) => {
          debugger;
          console.log(this.projectid, this.clid, this.clip, this.re, this.status);
          console.log("First", data);
          this.link = data.toString();
          if (this.link.includes("http://") || this.link.includes("https://")) {
            console.log(this.link);
            window.open(this.link, "_self");
            this.isLoading = false;

          }
          else if (this.link.includes("There is some problem with network")) {
            console.log(this.link);
            this.networkBool = true;
            this.isLoading = false;
          }
          else if (this.status == "1" || this.status == "2" || this.status == "3" || this.status == "4") {
            this.networkBool = true;
            //this.link = this.decodeEntities(this.link);
            this.isLoading = false;
            // this.getVendorLinks();
            // console.log(this.vendorUrl);
          }
          else {
            this.CustomPageEnable = true;
            this.custompagetext = data.toString(); // this.decodeEntities( data.toString());
            this.isLoading = false;
            console.log(this.custompagetext);
          }
          //console.log(data);
        }
      )
    }
  }

  continueClick() {
    this.isLoading = true;
    this.userService.continueClick(this.projectid, this.clid, this.clip, this.re).subscribe(
      (data) => {
        debugger;
        if (data.toString().split("||").length == 1) {
          this.linkNew = data.toString();
          if (this.linkNew.includes("http://") || this.linkNew.includes("https://")) {
            console.log("hi", this.linkNew)
            window.open(this.linkNew, "_self");
            this.isLoading = false;
          }
          else if (this.linkNew.includes("You have already participated in this study. Thank you for your time.")) {
            this.networkBool = true;
            this.link = this.linkNew;
            console.log(this.link);
            this.isLoading = false;
          }
          else if (this.linkNew.includes("You are not authorized to run this link in other Country. Thank you for your time.")) {
            this.networkBool = true;
            this.link = this.linkNew;
            console.log(this.link);
            this.isLoading = false;
          }
        }
        else if (data.toString().split("||").length == 2) {
          if (this.linkNew.includes("Your answers have been received and this survey is now completed")) {
            this.networkBool = true;
            this.link = this.linkNew;
            this.isLoading = false;
            // this.getVendorLinks();
            // console.log(this.vendorUrl);
          }
          else if (this.linkNew.includes("Thank you for sharing your opinions!")) {
            this.networkBool = true;
            this.link = this.linkNew;
            console.log(this.link)
            this.isLoading = false;
          }
          else if (this.linkNew.includes("Thanks for your opinion to share.")) {
            this.networkBool = true;
            this.link = this.linkNew;
            console.log(this.link);
            this.isLoading = false;
          }
          else if (this.linkNew.includes("Thank you for your interest and sharing your opinion.")) {
            this.networkBool = true;
            this.link = this.linkNew;
            console.log(this.link)
            this.isLoading = false;
          }
        }
        //console.log(data);
      }
    )
  }

  startsurvey() {
    this.isLoading = true;
    if (this.status == undefined) {
      this.userService.surveyUrl(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
        (data) => {
          debugger;
          if (data.toString().split("||").length == 1) {
            this.link = data.toString();
            if (this.link.includes("http://") || this.link.includes("https://")) {
              window.open(this.link, "_self");
              this.isLoading = false;
            }
            else if (this.link.includes("There is some problem with network")) {
              this.networkBool = true;
              this.isLoading = false;
            }
            else if (this.link.includes("You have already participated in this study. Thank you for your time.")) {
              this.networkBool = true;
              //console.log(this.link);
              this.isLoading = false;
            }
            else if (this.link.includes("You are not authorized to run this link in other Country. Thank you for your time.")) {
              this.networkBool = true;
              //console.log(this.link);
              this.isLoading = false;
            }
            else {
              this.CustomPageEnable = true;
              this.custompagetext = this.link //this.decodeEntities( data.toString());
              this.isLoading = false;
              console.log(this.custompagetext);
            }
          }
          else if (data.toString().split("||").length == 2) {
            this.link = data.toString().split("||")[0];
            if (this.link.includes("Your answers have been received and this survey is now completed")) {
              this.networkBool = true;
              this.isLoading = false;
              // this.getVendorLinks();
              // console.log(this.vendorUrl);
            }
            else if (this.link.includes("Thank you for sharing your opinions!")) {
              this.networkBool = true;
              this.isLoading = false;
            }
            else if (this.link.includes("Thanks for your opinion to share.")) {
              this.networkBool = true;
              this.isLoading = false;
            }
            else if (this.link.includes("Thank you for your interest and sharing your opinion.")) {
              this.networkBool = true;
              this.isLoading = false;
            }
          }
          //console.log(data);
        }
      )

    }
  }

  // getVendorLinks()
  // {
  //   var projId = this.projectid;
  //   this.userService.getVendorUrls(projId).subscribe(
  //     (data) => {
  //       if(data)
  //       {
  //         this.vendorUrl = data;
  //       }
  //     })
  // }



  loadRecaptchaScript(): void {
    const script = this._renderer.createElement('script');
    script.defer = true;
    script.async = true;
    script.src = 'https://www.google.com/recaptcha/api.js';
    this._renderer.appendChild(document.body, script);
    console.log('loaded');
  }


  isRecaptchaScriptLoaded(): boolean {
    // Check if the script is already loaded
    return document.querySelector('script[src="https://www.google.com/recaptcha/api.js"]') !== null;
  }

  // Call this method wherever you want to execute the invisible reCAPTCHA
  executeInvisibleRecaptcha(): void {
    // Check if the component is available
    if (this.invisiblerecaptchaBool) {
      debugger; // Execute the invisible reCAPTCHA
      this.invisibleRecaptcha.execute();
    } else {
      console.error('Invisible reCAPTCHA component not available.');

      console.log(this.invisiblerecaptchaBool);
    }

  }


  markSurveyTerminated() {
    this.toastr.error("You are not qualified for the survey", '', { progressBar: true });
    this.captchaBool = false;
    this.tableBool = false;
    this.status = "3";

    this.userService.MarkSurveyTerminated(this.projectid, this.clid, this.clip, this.re, this.status).subscribe(
      (data) => {
        var dataLength = data.toString().split('||').length;
        if (dataLength == 3) {
          this.link = data.toString().split('||')[0];
          var VendLinkUrl = data.toString().split('||')[1];
          this.networkBool = true;
          this.isLoading = false;
          if (VendLinkUrl) {
            setTimeout(() => {
              window.open(VendLinkUrl, "_self");
            }, 3000);
          }
        }
      })
  }


}
